import { ElementState } from "@creatomate/preview";

const getTimelineElementText = (element: ElementState, isSmallElement: boolean) => {
  if (isSmallElement) return "";

  return `${element.source.text?.substring(0, 20) || "Text"}${element.source.text?.length > 20 ? "..." : ""}`;
};

export default getTimelineElementText;
